import { useQuery } from 'react-query';
import axios from '../axios';
import { get } from 'lodash-es';
import { map } from 'lodash-es';
import { sortByMonth, sortByDate, sortByMonthAndYear } from '../misc';
import dateToMonth, { dateToMonthYear } from '../dateToMonth';
import moment from 'moment';

export function usePaginationCounts() {
  return useQuery('pagination/counts', () => {
    return axios.get('/users/paginationNumber').then((res) => {
      localStorage.setItem(
        'pageTotalHostChargers',
        get(res, 'data.TOTAL_HOST_CHARGERS', 0),
      );

      localStorage.setItem(
        'pageTotalHostSessions',
        get(res, 'data.TOTAL_HOST_SESSIONS', 0),
      );

      localStorage.setItem(
        'pageTotalCustomerSessions',
        get(res, 'data.TOTAL_CUSTOMER_SESSIONS', 0),
      );
      return res.data;
    });
  });
}

export function useHostChargerDetails(id) {
  return useQuery(['host/charger', id], ({ queryKey }) => {
    const [, id] = queryKey;
    // return axios.get(`/users/hostCharger/${id}`).then((res) => res.data);
    return axios.get(`/host/charger/${id}`).then((res) => res.data);
  });
}

export function useHostChargersListForMap(isHost) {
  return useQuery(
    'host/chargersForMap',
    () => {
      return axios.get('/host/charger').then((res) => {
        return res.data;
      });
    },
    { enabled: isHost !== undefined && isHost },
  );
}

export function useHostChargersForAllPeriods() {
  return useQuery('/host/chargerAllPeriod', () => {
    return axios.get('/host/chargerAllPeriod').then((res) => {
      return res.data;
    });
  });
}

export function useHostChargersList({ limit = 2, offset = 0, page = 1 }) {
  return useQuery(
    ['/host/chargers', limit, offset, page],
    ({ queryKey }) => {
      const [, limit, offset, page] = queryKey;

      return axios
        .get('/host/charger', { params: { limit, offset } })
        .then((res) => {
          localStorage.setItem('chargersPageNum', page);
          return res.data;
        });
    },
    { keepPreviousData: true },
  );
}

export function useHostConnectorsList() {
  return useQuery('/host/connectorAsHost', () =>
    axios.get('/users/connectorAsHost').then((res) => res.data),
  );
}

export function useHostChargingSessionsByCharger({
  cpid,
  limit = 2,
  offset = 0,
  page = 1,
}) {
  return useQuery(
    ['host/sessions', cpid, limit, offset, page],
    ({ queryKey }) => {
      const [, cpid, limit, offset, page] = queryKey;
      return axios
        .get(`/users/hostSessionWithPagination/${cpid}`, {
          params: {
            charger: true,
            limit,
            offset,
          },
        })
        .then((res) => {
          localStorage.setItem('chargerSessionsPageNum', page);
          localStorage.setItem('pageTotalChargerSessions', res.data.count);
          return res.data;
        });
    },
  );
}

export function useHostChargingSessions({
  limit = 2,
  offset = 0,
  startDate = '',
  endDate = '',
  orderBy = '',
  sortOrder = '',
  cpid = '',
}) {
  return useQuery(
    [
      'host/sessions',
      limit,
      offset,
      startDate,
      endDate,
      orderBy,
      sortOrder,
      cpid,
    ],
    ({ queryKey }) => {
      const [, limit, offset, startDate, endDate, orderBy, sortOrder, cpid] =
        queryKey;
      let params = {
        // charger: !!cpid,
        limit,
        offset,
        startDate: moment(startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        orderBy,
        sortOrder,
      };

      const apiURL = cpid
        ? `/users/hostSessionWithPagination/${cpid}`
        : '/users/hostSessionWithPagination';
      return axios.get(apiURL, { params }).then((res) => {
        return res.data;
      });
    },
    { enabled: !!(startDate && endDate) },
  );
}

export function useHostChargingSessionsExport({
  offset = 0,
  startDate = '',
  endDate = '',
  orderBy = '',
  sortOrder = '',
  cpid = '',
}) {
  return useQuery(
    [
      'host/sessionsexport',
      offset,
      startDate,
      endDate,
      orderBy,
      sortOrder,
      cpid,
    ],
    ({ queryKey }) => {
      const [, offset, startDate, endDate, orderBy, sortOrder, cpid] = queryKey;
      const params = {
        // charger: !!cpid,
        // limit,
        offset,
        startDate: moment(startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        orderBy,
        sortOrder,
      };
      const apiURL = cpid
        ? `/users/hostSessionWithPagination/${cpid}`
        : '/users/hostSessionWithPagination';
      return axios.get(apiURL, { params }).then((res) => {
        return res.data;
      });
    },
    { enabled: !!(startDate && endDate) },
  );
}

export function useHostFilteredChargingSessions({ limit = 2, offset = 0 }) {
  return useQuery(['host/chargingSessions', limit, offset], ({ queryKey }) => {
    const [, limit, offset] = queryKey;
    let params = {
      limit,
      offset,
    };

    const apiURL = '/host/chargingSessions';
    return axios.get(apiURL, { params }).then((res) => {
      return res.data;
    });
  });
}

export function useChargerHostAnalytics({ startDate = '', endDate = '' }) {
  return useQuery(
    ['/host/chargerHostAnalytics', startDate, endDate],
    ({ queryKey }) => {
      const [, startDate, endDate] = queryKey;
      const params = {
        startDate: moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };

      return axios.get('/host/chargerHostAnalytics', { params }).then((res) => {
        // let resp = {};
        // resp.data = [];
        // for (var key in res.data) {
        //   if (res.data.hasOwnProperty(key)) {
        //     resp.data.push({ ...res.data[key], CPID: key });
        //   }
        // }
        // console.log('resp.data-ankur-------', resp.data);
        return res.data;
      });
    },
    { enabled: !!(startDate && endDate) },
  );
}

export function useHostChargingSessionDetails(sessionId) {
  return useQuery(['host/sessions', sessionId], ({ queryKey }) => {
    const [, sessionId] = queryKey;
    return axios.get(`/users/hostSession/${sessionId}`).then((res) => res.data);
  });
}

export const createCharger = async ({
  ID,
  NAME,
  IS_DC,
  MODEL,
  VENDOR,
  ADDRESS,
  IS_ENABLED,
  LATITUDE,
  LONGITUDE,
  ZIPCODE,
  CONNECTORS,
  TIMING,
  ENERGY,
  BASE_KWH_COST,
  VEHICLE_TYPE,
  RESET_FORM,
}) => {
  return axios
    .post(`/charger`, {
      ID,
      NAME,
      IS_DC,
      MODEL,
      VENDOR,
      ADDRESS,
      IS_ENABLED,
      LATITUDE,
      LONGITUDE,
      ZIPCODE,
      CONNECTORS,
      TIMING,
      ENERGY,
      BASE_KWH_COST,
      VEHICLE_TYPE,
    })
    .then((res) => {
      RESET_FORM();
      return res.data;
    });
};

export const editCharger = async (updateValues) => {
  if (!updateValues.ID) {
    throw new Error('Please provide the Charger Id');
  }
  return axios
    .put(`/users/charger/${updateValues.ID}`, updateValues)
    .then((res) => {
      return res.data;
    });
};

export function useHostSingleMetrics() {
  return useQuery('host/singleMetrics', () =>
    axios.get('/host/analytics/singleMatric').then((res) => res?.data),
  );
}

export function useHostGeneralAnalyticsByYear() {
  return useQuery('host/generalHostAnalyticsbyYear', () =>
    axios
      .get('/users/generalHostAnalytics?byGrouping=2')
      .then((res) => res.data),
  );
}

export function useHostGeneralAnalyticsByMonth() {
  return useQuery('host/generalHostAnalyticsbyMonth', () =>
    axios.get('/users/generalHostAnalytics?byGrouping=1').then((res) => {
      res.data = sortByMonthAndYear(res.data);
      map(res.data, (row, index) => {
        if (row.DATE.length === 7) {
          res.data[index].DATE = dateToMonthYear(row.DATE);
        }
      });
      return sortByMonth(res.data);
    }),
  );
}

export function useGeneralHostAnalytics(limit = 10) {
  return useQuery(
    ['host/generalHostAnalyticsLast10Days', limit],
    ({ queryKey }) => {
      const [, limit] = queryKey;
      return axios
        .get(`/users/generalHostAnalytics?limit=${limit}&byGrouping=0`)
        .then((res) => {
          map(res.data, (row, index) => {
            if (row.DATE.length === 7) {
              res.data[index].DATE = dateToMonth(row.DATE);
            }
          });
          // return sortByDate(res.data);
          return res.data;
        });
    },
  );
}

export function useGeneralHostAnalyticsByChargerId(cpid, limit = 10) {
  return useQuery(
    ['host/generalHostAnalytics/byCharger', cpid, limit],
    ({ queryKey }) => {
      const [, cpid, limit] = queryKey;
      const url = `/users/generalHostAnalytics/${cpid}?byGrouping=0&limit=${limit}`;
      return axios.get(url).then((res) => {
        map(res.data, (row, index) => {
          if (row.DATE.length === 7) {
            res.data[index].DATE = dateToMonth(row.DATE);
          }
        });
        return sortByDate(res.data);
      });
    },
  );
}

export function useGeneralHostAnalyticsByChargerIdMonthly(cpid) {
  return useQuery(
    ['host/generalHostAnalytics/byChargerbyMonth', cpid],
    ({ queryKey }) => {
      const [, cpid] = queryKey;
      const url = `/users/generalHostAnalytics/${cpid}?byGrouping=1`;

      return axios.get(url).then((res) => {
        map(res.data, (row, index) => {
          if (row.DATE.length === 7) {
            res.data[index].DATE = dateToMonthYear(row.DATE);
          }
        });
        return sortByMonth(res.data);
      });
    },
  );
}

export function useGeneralHostAnalyticsByChargerIdYearly(cpid) {
  return useQuery(
    ['host/generalHostAnalytics/byChargerbyYear', cpid],
    ({ queryKey }) => {
      const [, cpid] = queryKey;
      const url = `/users/generalHostAnalytics/${cpid}?byGrouping=2`;

      return axios.get(url).then((res) => res.data);
    },
  );
}
